module.exports = __webpack_public_path__ + "static/michelle3-9dfcc2f772904f606584c0fcb05b78ca.png";